import type { FieldSchema } from './types';

type GetFormDataItem = (data: any, name: string) => any;

export const isFieldHidden = (field: FieldSchema, formData: any, getFormDataItem: GetFormDataItem): boolean => {
  let isHidden: any = field.hasOwnProperty('isHidden') ? getFormDataItem(formData, field.isHidden as string) : false;

  if (field?.isHidden === 'yield_evaluation.source') {
    const source = getFormDataItem(formData, 'yield_evaluation.source');
    isHidden = source !== 'monthly';
  }

  if (field.hasOwnProperty('revertHidden') && field?.revertHidden) {
    isHidden = !isHidden;
  }

  return isHidden;
};
